// The client's sign-off of levels, areas and systems, marked by the GC
// (back/routes/ownerSignOffs.js). Each call answers the whole list again, so
// the page redraws from one reply.
import { url, tokenRef } from "api";

const headers = () => {
  const h = { "Content-Type": "application/json" };
  const t = localStorage.getItem(tokenRef);
  if (t) h["Authorization"] = `Bearer ${t}`;
  return h;
};
const handle = async (r) => {
  const d = await r.json();
  if (!r.ok) { const e = new Error(d.err || "Request failed"); e.status = r.status; throw e; }
  return d;
};

export const listOwnerSignOffs = async (projectId) =>
  handle(await fetch(`${url}/projects/${projectId}/owner-sign-offs`, { headers: headers() }));

// body: { kind: 'level'|'area'|'system', level, areaId?, system?, date? ('YYYY-MM-DD', empty = today) }
export const setOwnerSignOff = async (projectId, body) =>
  handle(await fetch(`${url}/projects/${projectId}/owner-sign-offs`, { method: "PUT", headers: headers(), body: JSON.stringify(body) }));

export const withdrawOwnerSignOff = async (projectId, id) =>
  handle(await fetch(`${url}/projects/${projectId}/owner-sign-offs/${id}`, { method: "DELETE", headers: headers() }));

// WHO IS MAILED when a level, area or system is signed off (owner, 2026-10-21).
// recipients: [{ email, userId?, name?, companyId? }] - the server answers the
// list as saved plus any it refused ({ value, why }).
export const getOwnerSignOffRecipients = async (projectId) =>
  handle(await fetch(`${url}/projects/${projectId}/owner-sign-offs/recipients`, { headers: headers() }));

export const setOwnerSignOffRecipients = async (projectId, recipients) =>
  handle(await fetch(`${url}/projects/${projectId}/owner-sign-offs/recipients`, { method: "PUT", headers: headers(), body: JSON.stringify({ recipients }) }));
